import React, { useState } from 'react';
import ModalFilterProduct from 'components/Tvendo/Inventory/Operations/TakingInventory/Components/ModalFilterArticleProduct.jsx';
import { makeStyles, IconButton, InputAdornment, TextField, FormControlLabel } from '@material-ui/core';
import MultiComplete from 'components/Tvendo/Common/MultiComplete';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { Autocomplete } from '@material-ui/lab';
import { Search } from '@material-ui/icons';
import Checkbox from '@material-ui/core/Checkbox';

const useStyles = makeStyles((theme) => ({
  titleCheckBox:{
    marginTop: '5px',
    color: '#b1b1b1 !important',
  },
}));

export const InventoryHeader = (props) => {
  const classes = useStyles();
  const [openModalProduct, setOpenModalProduct] = useState(false);
  const { dataChanging, stateAprove, stateProduct, disabled, handleChange, updateField, permission } = props;
  const persistField = updateField || handleChange;
  const isExpiring = !!dataChanging?.is_expiring;
  // En tomas por vencer no hay boton Actualizar: zona/almacen se auto-guardan.
  // En tomas normales siguen guardandose con Actualizar (handleChange).
  const onHeaderChange = isExpiring ? persistField : handleChange;
  const { getTransfer, zones, warehouses, setWarehouses, listWarehouses } = props;
  const { providers, selectedProviders, setSelectedProviders } = props;
  const { marks, selectedMarks, setSelectedMarks } = props;
  const { categories, selectedCategories, setSelectedCategories } = props;
  const { lines, selectedLines, setSelectedLines } = props;
  const { families, selectedFamilies, setSelectedFamilies } = props;
  const { products, selectedProducts, setSelectedProducts } = props;
  const { jefeDia, setJefeDia, listJefeDia } = props;
  const { jefeNoche, setJefeNoche, listJefeNoche } = props;
  const { auditor, setAuditor, listAuditor } = props;
  const { showProvidersInfo, setShowProvidersInfo } = props;
  const { showMarksInfo, setShowMarksInfo } = props;
  const { showCategoriesInfo, setShowCategoriesInfo } = props;
  const { showLinesInfo, setShowLinesInfo } = props;
  const { showFamiliesInfo, setShowFamiliesInfo } = props;
  const { showProdStock, setShowProdStock } = props;

  return (
    <GridContainer>
      <ModalFilterProduct
      // TODO Hacer uno parecido pero para productos, que chape todos los filtros aplicados y los guarde en la variable products
        open={openModalProduct}
        setOpen={setOpenModalProduct}
        setProductSelect={setSelectedProducts}
        dataChanging={dataChanging}
        getTransfer={getTransfer}
        entity="logi/product"
        permission={permission}
        filterCustom={{
          base_business_partner_id: selectedProviders.map((p) => p.id),
          logi_category_id: selectedCategories.map((c) => c.id),
          logi_line_id: selectedLines.map((l) => l.id),
          logi_family_id: selectedFamilies.map((f) => f.id),
          state: 'A',
        }}
        details={dataChanging.details}
      />
      <GridItem xs={12} lg={2}>
        <MultiComplete
          label="Proveedores"
          selectAll
          limitTags={1}
          textField="CardName"
          options={providers}
          selected={selectedProviders}
          setSelected={setSelectedProviders}
          disabled={disabled || isExpiring}
        />
        {dataChanging.state === "PENDIENTE_FIRMA" && (
          <FormControlLabel
            control={
              <Checkbox
                checked={showProvidersInfo}
                onChange={(e) => setShowProvidersInfo(e.target.checked)}
              />
            }
            label="Mostrar info. Proveedores"
            classes={{ label: classes.titleCheckBox }}
          />
        )}
      </GridItem>
      <GridItem xs={12} lg={2}>
        <MultiComplete
          label="Marcas"
          selectAll
          limitTags={1}
          textField="logi_mark_description"
          options={marks}
          selected={selectedMarks}
          setSelected={setSelectedMarks}
          required
          disabled={!selectedProviders.length || disabled || isExpiring}
        />
        {dataChanging.state === "PENDIENTE_FIRMA" && (
          <FormControlLabel
          control={
            <Checkbox
            checked={showMarksInfo}
            onChange={(e) => setShowMarksInfo(e.target.checked)}
            />
          }
          label="Mostrar info. Marcas"
          classes={{ label: classes.titleCheckBox }}
          />
        )}
      </GridItem>
      <GridItem xs={12} lg={2}>
        <MultiComplete
          label="Categorías"
          selectAll
          limitTags={1}
          textField="description"
          options={categories}
          selected={selectedCategories}
          setSelected={setSelectedCategories}
          disabled={!selectedProviders.length || disabled || isExpiring}
        />
        {dataChanging.state === "PENDIENTE_FIRMA" && (
          <FormControlLabel
          control={
            <Checkbox
            checked={showCategoriesInfo}
            onChange={(e) => setShowCategoriesInfo(e.target.checked)}
            />
          }
          label="Mostrar info. Categorías"
          classes={{ label: classes.titleCheckBox }}
          />
        )}
      </GridItem>
      <GridItem xs={12} lg={2}>
        <MultiComplete
          label="Líneas"
          selectAll
          limitTags={1}
          textField="description"
          options={lines}
          selected={selectedLines}
          setSelected={setSelectedLines}
          disabled={!selectedCategories.length || disabled || isExpiring}
        />
        {dataChanging.state === "PENDIENTE_FIRMA" && (
          <FormControlLabel
          control={
            <Checkbox
            checked={showLinesInfo}
              onChange={(e) => setShowLinesInfo(e.target.checked)}
              />
          }
          label="Mostrar info. Líneas"
          classes={{ label: classes.titleCheckBox }}
          />
        )}
      </GridItem>
      <GridItem xs={12} lg={2}>
        <MultiComplete
          label="Familias"
          selectAll
          limitTags={1}
          textField="description"
          options={families}
          selected={selectedFamilies}
          setSelected={setSelectedFamilies}
          disabled={!selectedLines.length || disabled || isExpiring}
        />
        {dataChanging.state === "PENDIENTE_FIRMA" && (
          <FormControlLabel
          control={
            <Checkbox
            checked={showFamiliesInfo}
            onChange={(e) => setShowFamiliesInfo(e.target.checked)}
            />
          }
          label="Mostrar info. Familias"
          classes={{ label: classes.titleCheckBox }}
          />
        )}
      </GridItem>
      <GridItem xs={12} lg={2}>
        <TextField label="Productos" margin="normal" disabled={stateProduct || isExpiring} InputProps={{
          readOnly: true, endAdornment: (
            <InputAdornment position="end">
              <IconButton disabled={stateProduct} onClick={() => setOpenModalProduct(true)}>
                <Search style={{ color: '#4caf50' }}/>
              </IconButton>
            </InputAdornment>
          )
        }} />
        {dataChanging.id !== undefined && dataChanging.state !== 'BORRADOR' && (
          <FormControlLabel
            control={
              <Checkbox
              checked={showProdStock}
              onChange={(e) => setShowProdStock(e.target.checked)}
              />
            }
            label="Mostrar productos sin stock"
            classes={{ label: classes.titleCheckBox }}
          />
        )}
        {/* <MultiComplete
          label="Productos"
          selectAll
          limitTags={1}
          textField="ItemName"
          options={products}
          selected={selectedProducts}
          setSelected={setSelectedProducts}
          disabled={!selectedFamilies.length || disabled}
        /> */}
      </GridItem>
      <GridItem xs={12} lg={1}>
        <Autocomplete
          disableClearable
          options={zones}
          getOptionLabel={(option) => `${option.description}`}
          value={zones.find((item) => item.id === dataChanging.base_zone_id) || null}
          renderInput={(params) => (
            <TextField {...params} label="Zonas" margin="normal" fullWidth />
          )}
          onChange={(e, item) => {
            setWarehouses([]);
            handleChange("logi_warehouse_id", null);
            onHeaderChange("base_zone_id", item ? item.id : null);
            if (item) listWarehouses(item?.logi_warehouse_id || null);
          }}
          required
          disabled={disabled}
        />
      </GridItem>
      <GridItem xs={12} lg={2}>
        <Autocomplete
          disableClearable
          options={warehouses}
          getOptionLabel={(option) => `${option.WhsName}`}
          value={warehouses.find((item) => item.id === dataChanging.logi_warehouse_id) || null}
          renderInput={(params) => (
            <TextField {...params} label="Almacenes" margin="normal" fullWidth />
          )}
          onChange={(_, item) => {
            onHeaderChange("logi_warehouse_id", item ? item.id : null);
          }}
          disabled={!dataChanging.base_zone_id || disabled}
          required
        />
      </GridItem>
      <GridItem xs={12} lg={2}>
        {/* <TextField
          label="Jefe almacén día"
          fullWidth
          type="text"
          name="jefe_almacen_dia"
          margin="normal"
          value={dataChanging.jefe_almacen_dia || ''}
          onChange={(e) => handleChange('jefe_almacen_dia', e.target.value)}
          disabled={stateAprove}
          inputProps={{ maxLength: 30 }}
        /> */}
        {/* <Autocomplete
          disableClearable
          options={jefeDia}
          getOptionLabel={(option) => `${option.name}`}
          value={jefeDia.find((item) => item.id === dataChanging.jefe_almacen_dia_id) || null}
          renderInput={(params) => (
            <TextField {...params} label="Jefe almacén día" margin="normal" fullWidth />
          )}
          onChange={(_, item) => {
            handleChange("jefe_almacen_dia_id", item ? item.id : null);
          }}
          disabled={!dataChanging.jefe_almacen_dia_id || stateAprove}
          required
        /> */}
        <Autocomplete
          disableClearable
          options={jefeDia}
          getOptionLabel={(option) => `${option.name}`}
          value={jefeDia.find((item) => item.id === dataChanging.jefe_almacen_dia_id) || null}
          renderInput={(params) => (
            <TextField {...params} label="Jefe almacén día" margin="normal" fullWidth />
          )}
          onChange={(e, item) => {
            onHeaderChange("jefe_almacen_dia_id", item ? item.id : null);
          }}
          required
          disabled={stateAprove}
        />
      </GridItem>
      <GridItem xs={12} lg={2}>
        {/* <TextField
          label="Jefe almacén noche"
          fullWidth
          type="text"
          name="jefe_almacen_noche"
          margin="normal"
          value={dataChanging.jefe_almacen_noche || ''}
          onChange={(e) => handleChange('jefe_almacen_noche', e.target.value)}
          disabled={stateAprove}
          inputProps={{ maxLength: 30 }}
        /> */}
        <Autocomplete
          disableClearable
          options={jefeNoche}
          getOptionLabel={(option) => `${option.name}`}
          value={jefeNoche.find((item) => item.id === dataChanging.jefe_almacen_noche_id) || null}
          renderInput={(params) => (
            <TextField {...params} label="Jefe almacén noche" margin="normal" fullWidth />
          )}
          onChange={(_, item) => {
            onHeaderChange("jefe_almacen_noche_id", item ? item.id : null);
          }}
          disabled={stateAprove}
          required
        />
      </GridItem>
      <GridItem xs={12} lg={2}>
        {/* <TextField
          label="Auditor"
          fullWidth
          type="text"
          name="auditor"
          margin="normal"
          value={dataChanging.auditor || ''}
          onChange={(e) => handleChange('auditor', e.target.value)}
          disabled={stateAprove}
          inputProps={{ maxLength: 30 }}
        /> */}
        <Autocomplete
          disableClearable
          options={auditor}
          getOptionLabel={(option) => `${option.name}`}
          value={auditor.find((item) => item.id === dataChanging.auditor_id) || null}
          renderInput={(params) => (
            <TextField {...params} label="Auditor" margin="normal" fullWidth />
          )}
          onChange={(_, item) => {
            onHeaderChange("auditor_id", item ? item.id : null);
          }}
          disabled={stateAprove}
          required
        />
      </GridItem>
      <GridItem xs={12} lg={2}>
        <TextField
          label="Comentarios"
          fullWidth
          type="text"
          name="comments"
          margin="normal"
          value={dataChanging.comments || ''}
          onChange={(e) => handleChange('comments', e.target.value)}
          onBlur={(e) => onHeaderChange('comments', e.target.value)}
          disabled={disabled}
          inputProps={{ maxLength: 100 }}
        />
      </GridItem>
    </GridContainer>
  );
};

